"use client";

import { ReactNode, useEffect } from "react";

export const WebEngageWrapper = ({ children }: { children: ReactNode }) => {
  useEffect(() => {
    if ((window as any).webengage) {
      (window as any).webengage.init(process.env.NEXT_PUBLIC_WEB_ENGAGE_KEY);
    }
  }, []);

  return <>{children}</>;
};
